import { Button, styled } from "@mui/material";
import { IStyledFilterButtonProps } from "./types";

const StyledFilterButton = styled(Button,{
    shouldForwardProp: prop => !["isSelected"].includes(prop.toString())
})<IStyledFilterButtonProps>(({ theme, isSelected }) => ({
    backgroundColor: isSelected ? (theme as any).palette.neutral.darkest : (theme as any).palette.neutral.darker,
    color: isSelected ? (theme as any).palette.neutral.lighter : (theme as any).palette.neutral.light,
    borderRadius: (theme as any).shape.border.general.radius[8],
    padding: theme.spacing(1),
    textTransform: "none",
    "&:hover": {
        backgroundColor: isSelected ? (theme as any).palette.neutral.darkest : (theme as any).palette.neutral.darker,
    },
    "&.Mui-disabled": {
        backgroundColor: (theme as any).palette.neutral.darkest,
        color: (theme as any).palette.neutral.lighter,
    },
}))

export { StyledFilterButton };